import React, { useState, useEffect } from 'react';
import useLayoutStore from '@/stores/layout/layoutStore';

const JoyrideCustomTooltip = ({
  continuous,
  index,
  step,
  backProps,
  primaryProps,
  skipProps,
  tooltipProps,
  isLastStep,
}) => {
  const isDarkMode = useLayoutStore((state) => state.isDarkMode);
  const [inputHasValue, setInputHasValue] = useState(false);

  const tooltipBg = isDarkMode ? '#2C2A46' : '#ffffff';
  const tooltipText = isDarkMode ? '#F3F4F6' : '#111827';
  const tooltipSecondary = isDarkMode ? '#9CA3AF' : '#6B7280';

  const requireInput = step.data?.requireInput;
  const hideNextButton = step.data?.hideNextButton;
  const inputSelector = step.data?.inputSelector;

  useEffect(() => {
    if (!requireInput || !inputSelector) return;

    const checkValue = () => {
      const el = document.querySelector(inputSelector);
      if (el) {
        setInputHasValue(el.value && el.value.trim().length > 0);
      }
    };

    checkValue();
    const interval = setInterval(checkValue, 300);

    const el = document.querySelector(inputSelector);
    const handler = () => checkValue();
    if (el) {
      el.addEventListener('input', handler);
    }

    return () => {
      clearInterval(interval);
      if (el) {
        el.removeEventListener('input', handler);
      }
    };
  }, [requireInput, inputSelector]);

  const isNextDisabled = requireInput && !inputHasValue;
  const showNext = !hideNextButton;

  const nextLabel = isLastStep && step.locale?.last
    ? step.locale.last
    : step.locale?.next || (continuous ? 'Next' : 'Got it');

  return (
    <div
      {...tooltipProps}
      style={{
        backgroundColor: tooltipBg,
        color: tooltipText,
        borderRadius: 12,
        width: 380,
        fontFamily: 'Inter, "Inter Variable", ui-sans-serif, system-ui, sans-serif',
        fontSize: 13,
        lineHeight: 1.25,
        boxSizing: 'border-box',
        padding: 0,
      }}
    >
      {step.title && (
        <div style={{
          fontSize: 14,
          lineHeight: 1.4,
          fontWeight: 600,
          padding: '20px 20px 0',
          color: tooltipText,
        }}>
          {step.title}
        </div>
      )}
      <div style={{
        padding: '20px 20px 16px',
        fontSize: 13,
        lineHeight: 1.5,
        color: tooltipText,
      }}>
        {step.content}
      </div>
      {(showNext || step.showSkipButton || index > 0) && (
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: 0,
          padding: '0 20px 20px',
        }}>
          <div>
            {step.showSkipButton && (
              <button {...skipProps} style={{
                backgroundColor: 'transparent',
                border: 0,
                color: tooltipSecondary,
                fontSize: 13,
                fontWeight: 500,
                padding: 8,
                cursor: 'pointer',
                fontFamily: 'inherit',
              }}>
                Skip
              </button>
            )}
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            {index > 0 && (
              <button {...backProps} style={{
                backgroundColor: 'transparent',
                border: 0,
                borderRadius: 12,
                color: '#5745FA',
                fontSize: 13,
                fontWeight: 500,
                padding: 8,
                cursor: 'pointer',
                fontFamily: 'inherit',
              }}>
                Back
              </button>
            )}
            {showNext && (
              <button
                {...primaryProps}
                disabled={isNextDisabled}
                onClick={isNextDisabled ? undefined : primaryProps.onClick}
                style={{
                  backgroundColor: isNextDisabled ? '#a0a0a0' : 'var(--v3-purple-primary, #5745FA)',
                  border: `1px solid ${isNextDisabled ? '#a0a0a0' : 'var(--v3-purple-primary, #5745FA)'}`,
                  borderRadius: 12,
                  color: '#fff',
                  fontSize: 13,
                  fontWeight: 500,
                  padding: '10px 24px',
                  cursor: isNextDisabled ? 'not-allowed' : 'pointer',
                  fontFamily: 'inherit',
                  opacity: isNextDisabled ? 0.6 : 1,
                  outline: 'none',
                }}
              >
                {nextLabel}
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default JoyrideCustomTooltip;
